module.exports = __webpack_public_path__ + "images/a7769bdc5d94e84dd93157584ef8c2b64b7854cb187e48b0fe0a0864fb21e5bc.svg";